import React, { FC } from 'react'
import InstancesComponent from './Component'
import { useInstancesHook } from './Hooks'

const Instances: FC = () => {
  return <InstancesComponent {...useInstancesHook()} />
}
export default Instances
